module.exports = __webpack_public_path__ + "static/media/geoloc--plain.8e87465b.svg";